export const permissions = {
    system: {
        system: "system:system",
    },
    me: {
        show: "me:show",
        edit: "me:edit",
    },
    mandanten: {
        list: "mandanten:list",
        show: "mandanten:show",
        create: "mandanten:create",
        edit: "mandanten:edit",
        delete: "mandanten:delete",
        own_list: "mandanten:own:list",
        own_show: "mandanten:own:show",
        own_edit: "mandanten:own:edit",
    },
    aufgaben: {
        list: "aufgaben:list",
        show: "aufgaben:show",
        create: "aufgaben:create",
        edit: "aufgaben:edit",
        delete: "aufgaben:delete",
        own_list: "aufgaben:own:list",
        own_show: "aufgaben:own:show",
        own_create: "aufgaben:own:create",
        own_edit: "aufgaben:own:edit",
        own_delete: "aufgaben:own:delete",
    },
    unteraufgaben: {
        list: "unteraufgaben:list",
        show: "unteraufgaben:show",
        create: "unteraufgaben:create",
        edit: "unteraufgaben:edit",
        delete: "unteraufgaben:delete",
        own_list: "unteraufgaben:own:list",
        own_show: "unteraufgaben:own:show",
        own_create: "unteraufgaben:own:create",
        own_edit: "unteraufgaben:own:edit",
        own_delete: "unteraufgaben:own:delete",
    },
    phonenumbers: {
        show: "phonenumbers:show",
        edit: "phonenumbers:edit",
    },
    kontakte: {
        list: "kontakte:list",
        show: "kontakte:show",
        own_list: "kontakte:own:list",
        own_show: "kontakte:own:show",
    },
    tools: {
        list: "tools:list",
        show: "tools:show",
        edit: "tools:edit",
    },
    freedays: {
        list: "freedays:list",
        create: "freedays:create",
        delete: "freedays:delete",
        own_list: "freedays:own:list",
        own_create: "freedays:own:create",
        own_delete: "freedays:own:delete",
    },
    schedulers: {
        list: "schedulers:list",
        show: "schedulers:show",
        create: "schedulers:create",
        edit: "schedulers:edit",
        delete: "schedulers:delete",
        own_list: "schedulers:own:list",
        own_show: "schedulers:own:show",
        own_create: "schedulers:own:create",
        own_edit: "schedulers:own:edit",
        own_delete: "schedulers:own:delete",
    },
    roles: {
        mandantAnrufer: "mandant_anrufer:mandant_anrufer",
    },
}